module.exports = __webpack_public_path__ + "static/media/loginBg.92392461.jpg";